import * as React from "react";
import type { SxProps } from "@mui/material";
import { Box, IconButton, MenuItem, MenuList, Popover, Tooltip } from "@mui/material";
import { DotsThreeIcon } from "@phosphor-icons/react/dist/ssr/DotsThree";

import { usePopover } from "@/hooks/use-popover";

interface TableAction {
	label: string;
	icon?: React.ReactNode;
	onClick: () => void;
	sx?: SxProps;
	disabled?: boolean;
	hidden?: boolean;
}

export function TableActions({
	actions,
	popoverActions,
	isPopoverView = false,
}: {
	actions: TableAction[];
	popoverActions?: TableAction[];
	isPopoverView?: boolean;
}) {
	const menuActions = usePopover();

	if (!isPopoverView) {
		return (
			<Box sx={{ display: "flex", alignItems: "center", gap: 0 }}>
				{actions
					.filter((action) => !action.hidden)
					.map((action) => (
						<Tooltip key={action.label} title={action.label} arrow>
							<IconButton key={action.label} onClick={action.onClick} sx={{ ...action.sx }} disabled={action.disabled}>
								{action.icon}
							</IconButton>
						</Tooltip>
					))}
			</Box>
		);
	}

  if (popoverActions?.length === 0) {
    return;
  }

	return (
		<Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
			<Box sx={{ display: "flex", alignItems: "center", gap: 0 }}>
				{actions
					.filter((action) => !action.hidden)
					.map((action) => (
						<Tooltip key={action.label} title={action.label} arrow>
							<IconButton key={action.label} onClick={action.onClick} sx={{ ...action.sx }} disabled={action.disabled}>
								{action.icon}
							</IconButton>
						</Tooltip>
					))}
			</Box>
			<IconButton
				onClick={menuActions.handleOpen}
				ref={menuActions.anchorRef as React.RefObject<HTMLButtonElement>}
				sx={{ transform: "rotate(90deg)" }}
			>
				<DotsThreeIcon />
			</IconButton>
			<Popover
				open={menuActions.open}
				anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
				transformOrigin={{ horizontal: "left", vertical: "top" }}
				anchorEl={menuActions.anchorRef.current}
				onClose={menuActions.handleClose}
				slotProps={{ paper: { sx: { p: "0" } } }}
			>
				<MenuList sx={{ px: 0.5, py: 0.5, minWidth: "150px" }} tabIndex={-1}>
					{popoverActions?.map((action) => (
						<li key={action.label}>
							<MenuItem
								onClick={() => {
									action.onClick();
									menuActions.handleClose();
								}}
								sx={{
									fontSize: "14px",
									gap: 1,
									mt: 0.5,
									...action.sx,
								}}
								disabled={action.disabled}
							>
								{action.icon}
								{action.label}
							</MenuItem>
						</li>
					))}
				</MenuList>
			</Popover>
		</Box>
	);
}
